import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";
import { CoreStoreFacade } from "@modules/+new/core/core-store/domain/+state/core-store.facade";

@Component({
	selector: "empty",
	templateUrl: "./empty.component.html",
	styleUrls: ["./empty.component.scss"],
	standalone: false
})
export class EmptyComponent {
	@Input() public headline: string = "";
	@Input() public textLight: boolean = false;
	@Input() public loading: boolean = null;
	@Input() public text: string = "";
	@Input() public addClasses: string = "";
	@Input() public buttonIcon: string = "";
	@Input() public buttonText: string = "";
	@Input() public addButtonClass: string = "";
	@Output() public buttonClick = new EventEmitter();

	public constructor(
		private readonly coreStoreFacade: CoreStoreFacade,
		private translationService: TranslationService
	) {}

	public get isLoading(): boolean {
		return this.loading != null ? this.loading : this.coreStoreFacade.coreStoreSnapshot.isApiLoading;
	}

	public getHeadline(): string {
		return this.isLoading ? this.translationService.translate("loading") : this.headline;
	}
}
